import type { EmailBlockSchema, EmailBlockType, EmailCatalogMap } from './types';
import { EMAIL_CATALOG, EMAIL_BLOCK_TYPES } from './email-catalog';

export * from './types';
export { EMAIL_CATALOG, EMAIL_BLOCK_TYPES } from './email-catalog';
export { resolveBlockIcon } from './icons';

/** The email block catalog. Emails always support the visual builder (no per-type gating like widgets). */
export function getEmailCatalog(): EmailCatalogMap {
  return EMAIL_CATALOG;
}

/** Whether the visual builder is available for emails at all (always true; kept for symmetry/gating). */
export function supportsEmailVisualBuilder(): boolean {
  return Object.keys(EMAIL_CATALOG).length > 0;
}

/** Looks up the schema for a block type (undefined if unknown). */
export function getBlockSchema(type: EmailBlockType | string): EmailBlockSchema | undefined {
  return EMAIL_CATALOG[type as EmailBlockType];
}

/**
 * Palette entries (addable blocks) for a given template, in catalog order. Hides blocks that are
 * not palette-visible, and template-scoped blocks that don't apply to the current template.
 */
export function getPaletteEntries(templateKey: string | undefined): EmailBlockSchema[] {
  return EMAIL_BLOCK_TYPES.map(type => EMAIL_CATALOG[type]).filter(schema => {
    if (!schema.paletteVisible) return false;
    if (schema.templateScoped && templateKey && !schema.templateScoped.includes(templateKey)) return false;

    return true;
  });
}
